import { useState } from "react";
import { fileSrc } from "@/lib/api";

const src = (p) => fileSrc(p?.url || p?.path || "");

export default function BeforeAfter({ before = [], after = [], testid = "before-after" }) {
  const [bi, setBi] = useState(0); const [ai, setAi] = useState(0);
  const [mode, setMode] = useState("slider"); const [pos, setPos] = useState(50);
  if (!before.length || !after.length) return <p className="text-sm text-slate-400">Ajoutez au moins une photo avant et une photo après pour comparer.</p>;
  const b = src(before[Math.min(bi, before.length - 1)]); const a = src(after[Math.min(ai, after.length - 1)]);
  const Pick = ({ list, i, set, label }) => (
    <div className="flex gap-1.5 overflow-x-auto pb-1">
      <span className="text-[11px] text-slate-500 shrink-0 self-center w-10">{label}</span>
      {list.map((p, k) => <button key={k} type="button" onClick={() => set(k)} className={`shrink-0 rounded-md overflow-hidden border-2 ${k === i ? "border-emerald-500" : "border-transparent"}`}><img src={src(p)} alt="" className="w-12 h-12 object-cover" /></button>)}
    </div>
  );
  return (
    <div className="space-y-2" data-testid={testid}>
      <div className="flex gap-2">
        {[["slider", "Curseur avant/après"], ["side", "Côte à côte"]].map(([k, l]) => <button key={k} type="button" data-testid={`${testid}-mode-${k}`} onClick={() => setMode(k)} className={`rounded-full px-3 py-1.5 text-xs border ${mode === k ? "bg-slate-900 text-white border-slate-900" : "border-slate-200 text-slate-600"}`}>{l}</button>)}
      </div>
      {mode === "slider" ? (
        <div className="relative w-full max-w-xl aspect-[4/3] rounded-xl overflow-hidden bg-slate-100 select-none" data-testid={`${testid}-slider`}>
          <img src={a} alt="Après" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 overflow-hidden" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}><img src={b} alt="Avant" className="absolute inset-0 w-full h-full object-cover" /></div>
          <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow" style={{ left: `${pos}%` }} />
          <span className="absolute left-2 top-2 text-[10px] font-bold bg-black/60 text-white rounded px-1.5 py-0.5">AVANT</span>
          <span className="absolute right-2 top-2 text-[10px] font-bold bg-emerald-600 text-white rounded px-1.5 py-0.5">APRÈS</span>
          <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))} data-testid={`${testid}-range`} className="absolute bottom-2 left-4 right-4 w-[calc(100%-2rem)]" aria-label="Curseur avant après" />
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-2 max-w-xl" data-testid={`${testid}-side`}>
          <div className="relative"><img src={b} alt="Avant" className="w-full aspect-[4/3] object-cover rounded-lg" /><span className="absolute left-1.5 top-1.5 text-[10px] font-bold bg-black/60 text-white rounded px-1.5">AVANT</span></div>
          <div className="relative"><img src={a} alt="Après" className="w-full aspect-[4/3] object-cover rounded-lg" /><span className="absolute left-1.5 top-1.5 text-[10px] font-bold bg-emerald-600 text-white rounded px-1.5">APRÈS</span></div>
        </div>
      )}
      <Pick list={before} i={bi} set={setBi} label="Avant" />
      <Pick list={after} i={ai} set={setAi} label="Après" />
    </div>
  );
}
